import React from 'react';

import EnclosureConfigurator from './EnclosureConfigurator.jsx';
import EnclosureAccessoryConfigurator from './EnclosureAccessoryConfigurator.jsx';
import EnclosureClimateConfigurator from './EnclosureClimateConfigurator.jsx';
import PatchcordConfigurator from './PatchcordConfigurator.jsx';
import PigtailConfigurator from './PigtailConfigurator.jsx';
import ElectTechClosetConfigurator from './ElectTechClosetConfigurator.jsx';
import ElectTechClosetAccessoryConfigurator from './ElectTechClosetAccessoryConfigurator.jsx';
import LanCableConfigurator from './LanCableConfigurator.jsx';
import StabilizerConfigurator from './StabilizerConfigurator.jsx';
import KnsConfigurator from './KnsConfigurator.jsx';
import UermConfigurator from './UermConfigurator.jsx';
import ItkTenderConfigurator from './ItkTenderConfigurator.jsx';
import OniEquipmentConfigurator from './OniEquipmentConfigurator.jsx';
import NkuConfigurator from './NkuConfigurator.jsx';
import Vr32iConfigurator from './Vr32iConfigurator.jsx';
import BapConfigurator from './BapConfigurator.jsx';
import SelectivityConfigurator from './SelectivityConfigurator.jsx';
import LanConfigurator from './LanConfigurator.jsx';
import OpticConfigurator from './OpticConfigurator.jsx';
import LEDStripConfigurator from './LEDStripConfigurator.jsx';
import PowerSwitcherConfigurator from './PowerSwitcherConfigurator.jsx';
import GroundSelectionConfigurator from './GroundSelectionConfigurator.jsx';
import HatchConfigurator from './HatchConfigurator.jsx';
import EnclosureOrderConfigurator from "./EnclosureOrderConfigurator.jsx";
import PipeConfigurator from "./PipeConfigurator.jsx";
import GroundCalculationConfigurator from './GroundCalculationConfigurator.jsx';
import DocPage from './DocPage.jsx';
import LightningProtectionCalcConfigurator from './LightningProtectionCalcConfigurator.jsx';
import GroundLightNav from './GroundLightNav.jsx';
import CorridorConfigurator from './CorridorConfigurator.jsx';
import EnclosureAccessoryTitanConfigurator from "./EnclosureAccessoryTitanConfigurator.jsx";
import BapLabelConfigurator from "./BapLabelConfigurator.jsx";
import IbpConfigurator from "./IbpConfigurator.jsx";


class ConfiguratorRouter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			type: this.props.type,
			locale: this.props.locale,
			prevCfgState: null
		};
	}

	onSwitchConfigurator(type, prevCfgState) {
		this.setState({
			type,
			prevCfgState
		});
	}

	render() {
		let cfg = null;

		switch (this.state.type) {
			case 'itk_tender_calc':
				cfg = <ItkTenderConfigurator locale={this.state.locale}/>;
				break;

			case 'uerm':
				cfg = <UermConfigurator locale={this.state.locale}/>;
				break;

			case 'kns':
				cfg = <KnsConfigurator locale={this.state.locale}/>;
				break;

			case 'lan_cable':
				cfg = <LanCableConfigurator/>;
				break;

			case 'stabilizer':
				cfg = <StabilizerConfigurator locale={this.state.locale}/>;
				break;

			case 'enclosure':
				cfg = <EnclosureConfigurator onSwitchConfigurator={(type,state) => this.onSwitchConfigurator(type, state)} />;
				break;

			case 'enclosure_accessory':
				cfg = <EnclosureAccessoryConfigurator
					enclosure={this.state.prevCfgState && this.state.prevCfgState.item ? this.state.prevCfgState.item.article : null}
					onSwitchConfigurator={() => this.onSwitchConfigurator('enclosure')}/>;
				break;

			case 'enclosure_climate':
				cfg = <EnclosureClimateConfigurator locale={this.state.locale}/>;
				break;

			case 'enclosure_order':
				cfg = <EnclosureOrderConfigurator locale={this.state.locale}
																					onSwitchConfigurator={() => this.onSwitchConfigurator('enclosure')}/>;

				break;

			case 'patchcord':
				cfg = <PatchcordConfigurator onSwitchConfigurator={() => this.onSwitchConfigurator('pigtail')}/>;
				break;

			case 'pigtail':
				cfg = <PigtailConfigurator onSwitchConfigurator={() => this.onSwitchConfigurator('patchcord')}/>;
				break;

			case 'electTechCloset':
				cfg = <ElectTechClosetConfigurator
					locale={this.state.locale}
					onSwitchConfigurator={state => this.onSwitchConfigurator('electTechCloset_accessory', state)}/>;
				break;

			case 'bap':
				cfg = <BapConfigurator locale={this.state.locale}/>;
				break;

			case 'bap_label':
				cfg = <BapLabelConfigurator locale={this.state.locale}/>;
				break;

			case 'electTechCloset_accessory':
				cfg = <ElectTechClosetAccessoryConfigurator
					locale={this.state.locale}
					enclosure={this.state.prevCfgState && this.state.prevCfgState.item ? this.state.prevCfgState.item.article : null}
					onSwitchConfigurator={() => this.onSwitchConfigurator('electTechCloset')}/>;
				break;

			case 'selectivity':
				cfg = <SelectivityConfigurator locale={this.state.locale}/>;
				break;

			case 'led_strip':
				cfg = <LEDStripConfigurator locale={this.state.locale}/>;
				break;

			case 'oni_equipment':
				cfg = <OniEquipmentConfigurator locale={this.state.locale}/>;
				break;

			case 'nku':
				cfg = <NkuConfigurator locale={this.state.locale}/>;
				break;

			case 'vr32i':
				cfg = <Vr32iConfigurator locale={this.state.locale}/>;
				break;

			case 'lan':
				cfg = <LanConfigurator locale={this.state.locale}/>;
				break;
			case 'optic':
				cfg = <OpticConfigurator locale={this.state.locale}/>;
				break;
			case 'power':
				cfg = <PowerSwitcherConfigurator locale={this.state.locale}/>;
				break;
			case 'ground_select':
				cfg = <GroundSelectionConfigurator
					onNavConfigurator={() => this.onSwitchConfigurator('ground_light_nav')}
					onDocConfigurator={() => this.onSwitchConfigurator('doc')}
				/>;
				break;
			case 'hatch':
				cfg = <HatchConfigurator locale={this.state.locale}/>;
				break;
			case 'pipe':
				cfg = <PipeConfigurator locale={this.state.locale}/>;
				break;
			case 'ground_calc':
				cfg = <GroundCalculationConfigurator locale={this.state.locale}
					onNavConfigurator={() => this.onSwitchConfigurator('ground_light_nav')}
					onDocConfigurator={() => this.onSwitchConfigurator('doc')}
				/>;
				break;
			case 'doc':
				cfg = <DocPage
					onNavConfigurator={() => this.onSwitchConfigurator('ground_light_nav')}
				/>;
				break;
			case 'light_protect_calc':
				cfg = <LightningProtectionCalcConfigurator
					onNavConfigurator={() => this.onSwitchConfigurator('ground_light_nav')}
					onDocConfigurator={() => this.onSwitchConfigurator('doc')}
				/>;
				break;
			case 'ground_light_nav':
				cfg = <GroundLightNav
					onLightCalcConfigurator={() => this.onSwitchConfigurator('light_protect_calc')}
					onGroundCalcCalcConfigurator={() => this.onSwitchConfigurator('ground_calc')}
					onGroundSelectConfigurator={() => this.onSwitchConfigurator('ground_select')}
				/>;
				break;
			case 'corridor':
				cfg = <CorridorConfigurator />;
				break;
			case 'enclosure_accessory_titan':
				cfg = <EnclosureAccessoryTitanConfigurator locale={this.state.locale}/>;
				break;
			case 'ibp':
				cfg = <IbpConfigurator />;
				break;

		}

		return cfg;
	}
}

export default ConfiguratorRouter;



// WEBPACK FOOTER //
// ./src/react/ConfiguratorRouter.jsx